import styled from 'styled-components';

export const ToastsContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 20%;
  right: 20%;
  z-index: 1400;

  .MuiSnackbar-root {
    margin-bottom: 16px;
    position: relative;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;
